import { render } from "./BlockFormEdit.vue?vue&type=template&id=19ac380c&scoped=true"
import script from "./BlockFormEdit.vue?vue&type=script&lang=js"
export * from "./BlockFormEdit.vue?vue&type=script&lang=js"

import "./BlockFormEdit.vue?vue&type=style&index=0&id=19ac380c&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ac380c"]])

export default __exports__